import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import ReactMarkdown from 'react-markdown';
import { system as styledSystem } from '@styled-system/core';

export const SR_MARKDOWN_THEME_LEGAL = 'legal';
export const SR_MARKDOWN_THEME_PROPERTY_FEATURES = 'propertyFeatures';
export const SR_MARKDOWN_THEME_GREYCLIFF = 'greycliff';
export const SR_MARKDOWN_THEME_CALL_SCRIPT = 'callScript';
export const SR_MARKDOWN_THEME_UTILITY_PROFIT = 'utilityProfit';
export const SR_MARKDOWN_THEME_UTILITY_PROFIT_HELVETICA = 'utilityProfit helvetica';
export const SR_MARKDOWN_THEME_UTILITY_PROFIT_SMALL = 'utilityProfitSmall';
export const SR_MARKDOWN_THEME_UTILITY_PROFIT_SMALL_HELVETICA = 'utilityProfitSmall helvetica';
export const SR_MARKDOWN_THEME_OUTLINED = 'outlined';
export const SR_MARKDOWN_THEME_OUTLINED_HELVETICA = 'outlined helvetica';

const styledParser = styledSystem({
  width: true,
  minWidth: true,
  maxWidth: true,
  height: true,
  minHeight: true,
  maxHeight: true,
  margin: true,
  marginTop: true,
  marginBottom: true,
  marginRight: true,
  marginLeft: true,
  padding: true,
  border: true,
  borderTop: true,
  borderBottom: true,
  borderRadius: true,
  overflowX: true,
});

const SrMarkdown = ({ source, theme, escapeHtml, onRef, ..._styles }) => {
  return (
    <div ref={onRef} className={classnames('SrMarkdown', theme)} style={styledParser(_styles)}>
      <ReactMarkdown source={source} escapeHtml={escapeHtml} />
    </div>
  );
};

SrMarkdown.propTypes = {
  source: PropTypes.string.isRequired,
  theme: PropTypes.oneOf([
    SR_MARKDOWN_THEME_LEGAL,
    SR_MARKDOWN_THEME_PROPERTY_FEATURES,
    SR_MARKDOWN_THEME_GREYCLIFF,
    SR_MARKDOWN_THEME_UTILITY_PROFIT,
    SR_MARKDOWN_THEME_UTILITY_PROFIT_HELVETICA,
    SR_MARKDOWN_THEME_UTILITY_PROFIT_SMALL,
    SR_MARKDOWN_THEME_UTILITY_PROFIT_SMALL_HELVETICA,
    SR_MARKDOWN_THEME_OUTLINED,
    SR_MARKDOWN_THEME_OUTLINED_HELVETICA,
  ]),
  escapeHtml: PropTypes.bool,
  onRef: PropTypes.func,
};

SrMarkdown.defaultProps = {
  theme: SR_MARKDOWN_THEME_LEGAL,
};

SrMarkdown.displayName = 'SrMarkdown';

export default SrMarkdown;
